import { useLayoutEffect, useRef, useState } from 'react';
import 'react-circular-progressbar/dist/styles.css';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { Desktop, Mobile } from '../../App';
import { TextWithTooltip } from '../../components/common/TextWithTooltip';
import {
  BV,
  PO,
  UV,
  calculatePercentage,
  flipMeTitle,
  formatUSDNoDecimals,
  formatVP
} from '../../helpers/helperFunctions';
import { BIG_WHALE } from '../../routes/routes';
import { CaptionText, H1, H4, P1, P3 } from '../../styles/FontStyles';
import {
  Button,
  Flexed,
  ProgressBarWithPercentage
} from '../../styles/GlobalComponents';
import { color, colors } from '../../styles/GlobalStyles';
import { FlexCenter } from '../../styles/stylesStyled';
import {
  PackageRankMyProgressModel,
  PackageRankSelectedRewardModel
} from './Ranking.types';
import { Circle, MavieRank, RankImage, RankStatus } from './RankingStyled';
import { QualifiedPartner } from './QualifiedPartner';

import { ConnectWalletStatus } from '../FlipMeWallet/FlipMeBanner';
import { redeemFlipmeCardInRank } from '../FlipMeWallet/FlipMeWallet.actions';
import { useDispatch } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../app/hooks';

export const RankComponent = ({
  rank,
  handleClaim
}: {
  rank: PackageRankMyProgressModel;
  handleClaim: (rank: PackageRankMyProgressModel) => void;
}) => {
  const { flipmeCard } = useAppSelector((state) => state.wallets);
  const history = useHistory();
  const dispatch = useAppDispatch();
  const { t } = useTranslation('ranking');

  const ref = useRef<any | null>(null);
  const refChild = useRef<any | null>(null);

  const ref2 = useRef<any | null>(null);
  const refChild2 = useRef<any | null>(null);

  const ref3 = useRef<any | null>(null);
  const refChild3 = useRef<any | null>(null);

  const ref4 = useRef<any | null>(null);
  const refChild4 = useRef<any | null>(null);

  const [width, setWidth] = useState(0);
  const [widthChild, setWidthChild] = useState(0);

  const [width2, setWidth2] = useState(0);
  const [widthChild2, setWidthChild2] = useState(0);

  const [width3, setWidth3] = useState(0);
  const [widthChild3, setWidthChild3] = useState(0);

  const [width4, setWidth4] = useState(0);
  const [widthChild4, setWidthChild4] = useState(0);

  useLayoutEffect(() => {
    if (ref.current && ref2.current && ref3.current && ref4.current) {
      setWidth(ref.current.clientWidth);
      setWidthChild(refChild.current.clientWidth);

      setWidth2(ref2.current.clientWidth);
      setWidthChild2(refChild2.current.clientWidth);

      setWidth3(ref3.current.clientWidth);
      setWidthChild3(refChild3.current.clientWidth);

      setWidth4(ref4.current.clientWidth);
      setWidthChild4(refChild4.current.clientWidth);
    }
  }, [ref]);

  return (
    <MavieRank isNext={rank.isFutureRank} id={rank.name}>
      <RankImage image={rank.imageUrl} isActive={rank.isRankStatusActive}>
        <Desktop>
          <H1 color={color.colors.neutral0}>{rank.name}</H1>
        </Desktop>
        <Mobile>
          <H4 color={color.colors.neutral0}>{rank.name}</H4>
        </Mobile>
        {!rank.isFutureRank && (
          <RankStatus>
            <Desktop>
              <CaptionText color={color.colors.neutral50}>
                {t('current_rank_status')}{' '}
              </CaptionText>
            </Desktop>

            <FlexCenter>
              <Desktop>
                <P3 bold color={color.colors.neutral50}>
                  {rank.isRankStatusActive ? t('active') : t('inactive')}
                </P3>
              </Desktop>
              <Mobile>
                <CaptionText bold color={color.colors.neutral50}>
                  {rank.isRankStatusActive ? t('active') : t('inactive')}
                </CaptionText>
              </Mobile>
              <Circle
                color={
                  rank.isRankStatusActive
                    ? color.colors.success500
                    : color.colors.error500
                }
              />
            </FlexCenter>
          </RankStatus>
        )}
      </RankImage>
      <div>
        <Flexed center between mb='30' rowSM alignStartSM>
          <Flexed center gap='20px 80px' rowSM alignStartSM gapSM='20px' wrap>
            <div>
              <CaptionText mb='4' color={color.colors.neutral500} caps>
                {t('binary_weekly_cap')}
              </CaptionText>
              <P1 bold>
                {formatUSDNoDecimals(rank.weekCapRuleLimit)} USDT / {t('week')}
              </P1>
            </div>

            <div>
              <CaptionText mb='4' color={color.colors.neutral500} caps>
                {t('rewards')}
              </CaptionText>
              <P1 bold color={color.colors.neutral700}>
                {rank.rewards?.map(
                  (reward: PackageRankSelectedRewardModel, i: number) => {
                    return (
                      <P1 key={i} bold>
                        {reward.reward.name}
                      </P1>
                    );
                  }
                )}
              </P1>
            </div>
          </Flexed>

          <Desktop>
            {rank.name !== 'Qualified Partner' && (
              <Flexed>
                {/* {rank?.packageRankId === 7 && (
                  <Flexed column alignEnd>
                    {flipmeCard && (
                      <TextWithTooltip
                        tooltip={showToolTipCards(flipmeCard)}
                        margin='0 15px 0 0'
                        width='auto'
                      />
                    )}

                    <Button
                      w='215px'
                      mr='20'
                      disabled={isRankRedeemAvailable?.status !== 'available'}
                      onClick={() => {
                        if (flipMeStatus !== ConnectWalletStatus.CONNECTED) {
                          setIsOpen(true);
                        } else {
                          dispatch(redeemFlipmeCardInRank());
                        }
                      }}>
                      Activate Rank FlipME card
                    </Button>
                  </Flexed>
                )} */}
                <Button
                  w='215px'
                  mt={flipmeCard ? 20 : 0}
                  disabled={!rank.canClaimReward}
                  onClick={() => handleClaim(rank)}>
                  {rank.isRewardAlreadyClaimed
                    ? t('claimed_reward')
                    : t('claim_reward')}
                </Button>
              </Flexed>
            )}

            {rank.shouldDisplayActivateRankStatus && (
              <Button w='215px' mt='10' onClick={() => history.push(BIG_WHALE)}>
                {t('activate_status')}
              </Button>
            )}
          </Desktop>
        </Flexed>

        <QualifiedPartner rank={rank} />

        {rank.name !== 'Qualified Partner' && (
          <>
            <Flexed center between mb='10' gap='8px'>
              <CaptionText color={color.colors.neutral700} semiBold>
                {t('weak_team')}
              </CaptionText>

              <CaptionText right color={color.colors.neutral700}>
                {t('required')}: {formatVP(rank.paidTeamLimit)} {BV}
              </CaptionText>
            </Flexed>

            <ProgressBarWithPercentage
              progressWidth={width}
              progressValueWidth={widthChild}
              percentage={calculatePercentage(
                rank.paidTeamCurrent,
                rank.paidTeamLimit
              )}
              color={
                calculatePercentage(rank.paidTeamCurrent, rank.paidTeamLimit) >
                99
                  ? color.colors.success500
                  : color.colors.warning
              }>
              <div ref={ref}>
                <div ref={refChild}>
                  {rank.paidTeamCurrent === rank.paidTeamLimit
                    ? t('done')
                    : `${formatVP(rank.paidTeamCurrent)} ${BV}`}
                </div>
              </div>
            </ProgressBarWithPercentage>

            <Flexed center between gap='8px' mb='10'>
              <TextWithTooltip
                margin='0'
                tooltip={
                  <Flexed width='200px'>
                    {t('what_is_rule')}
                    <br />
                    <br />
                    {t('this_rule_applies')}
                  </Flexed>
                }>
                <CaptionText
                  color={color.colors.neutral700}
                  semiBold
                  style={{ display: 'inline' }}>
                  40 / 40 / 20 {t('direct_volume')}
                </CaptionText>
              </TextWithTooltip>
              <CaptionText right color={color.colors.neutral700}>
                {t('required')}: {formatVP(rank.directVolumeLimit)} {UV}
              </CaptionText>
            </Flexed>
            <ProgressBarWithPercentage
              progressWidth={width2}
              progressValueWidth={widthChild2}
              amount={rank.directVolumeCurrent}
              percentage={calculatePercentage(
                rank.directVolumeCurrent,
                rank.directVolumeLimit
              )}
              color={
                calculatePercentage(
                  rank.directVolumeCurrent,
                  rank.directVolumeLimit
                ) > 99
                  ? color.colors.success500
                  : color.colors.warning
              }>
              <div ref={ref2}>
                <div ref={refChild2}>
                  {rank.directVolumeCurrent === rank.directVolumeLimit
                    ? t('done')
                    : `${formatVP(rank.directVolumeCurrent)} ${UV}`}
                </div>
              </div>
            </ProgressBarWithPercentage>

            <Flexed center between gap='8px' mb='10'>
              <CaptionText color={color.colors.neutral700} semiBold>
                20% {t('in_strong_team')}
              </CaptionText>
              <CaptionText right color={color.colors.neutral700}>
                {t('required')}: {formatVP(rank.strongTeamLimit)} {UV}
              </CaptionText>
            </Flexed>
            <ProgressBarWithPercentage
              progressWidth={width3}
              progressValueWidth={widthChild3}
              amount={rank.strongTeamCurrent}
              percentage={calculatePercentage(
                rank.strongTeamCurrent,
                rank.strongTeamLimit
              )}
              color={
                calculatePercentage(
                  rank.strongTeamCurrent,
                  rank.strongTeamLimit
                ) > 99
                  ? color.colors.success500
                  : color.colors.warning
              }>
              <div ref={ref3}>
                <div ref={refChild3}>
                  {rank.strongTeamCurrent === rank.strongTeamLimit
                    ? t('done')
                    : `${formatVP(rank.strongTeamCurrent)} ${UV}`}
                </div>
              </div>
            </ProgressBarWithPercentage>

            <Flexed center between gap='8px' mb='10'>
              <CaptionText color={color.colors.neutral700} semiBold>
                {t('personal_orders')}
              </CaptionText>

              <CaptionText right color={color.colors.neutral700}>
                {t('required')}: {formatVP(rank.personalOrderLimit)} {PO}
              </CaptionText>
            </Flexed>
            <ProgressBarWithPercentage
              progressWidth={width4}
              progressValueWidth={widthChild4}
              amount={rank.personalOrderAmount}
              percentage={calculatePercentage(
                rank.personalOrderAmount,
                rank.personalOrderLimit
              )}
              color={
                calculatePercentage(
                  rank.personalOrderAmount,
                  rank.personalOrderLimit
                ) > 99
                  ? color.colors.success500
                  : color.colors.warning
              }>
              <div ref={ref4}>
                <div ref={refChild4}>
                  {rank.personalOrderAmount === rank.personalOrderLimit
                    ? t('done')
                    : `${formatVP(rank.personalOrderAmount)} ${PO}`}
                </div>
              </div>
            </ProgressBarWithPercentage>
          </>
        )}
        <Mobile>
          {rank.name !== 'Qualified Partner' && (
            <>
              {rank?.packageRankId === 7 && (
                <Button
                  w='100%'
                  mt='20'
                  disabled={!rank.canClaimReward}
                  onClick={() => handleClaim(rank)}>
                  {rank.isRewardAlreadyClaimed
                    ? t('claimed_reward')
                    : t('claim_reward')}
                </Button>
              )}
            </>
          )}
          {rank.shouldDisplayActivateRankStatus && (
            <Button w='215px' mt='10' onClick={() => history.push(BIG_WHALE)}>
              {t('activate_status')}
            </Button>
          )}
        </Mobile>
      </div>
    </MavieRank>
  );
};
